import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    aside: {
      background: theme.palette.background.default,
      padding: '1rem',

      '& > .MuiTypography-h1': {
        padding: '2rem 2rem 1.2rem ',
      },
    },
    list: {
      '& .MuiListItem-root': {
        borderRadius: 5,
        padding: '0.2rem 1.2rem',

        '& + .MuiListItem-root': {
          marginTop: '0.5rem',
        },

        '& .MuiTypography-body2': {
          fontWeight: 600,
          fontSize: '1.4rem',
          color: '#7A7A7A',
        },

        '& .MuiListItemIcon-root': {
          minWidth: 'initial',
          marginRight: '1rem',

          '& .material-symbols-outlined': {
            fontSize: 22,
            marginLeft: -2,
          },
        },

        '&.Mui-selected': {
          background: '#CCCEE5',

          '& .MuiTypography-body2': {
            color: theme.palette.secondary.main,
            fontWeight: 600,
            fontSize: '1.4rem',
          },
          '& .MuiSvgIcon-root': {
            color: theme.palette.secondary.main,
          },
        },
      },
    },
  }),
)
